import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProblemSections } from './components/ProblemSections';
import { SystemSection } from './components/SystemSection';
import { BonusesSection, ModulesSection } from './components/ContentSections';
import { OutcomesSection } from './components/OutcomesSection';
import { ObjectionsSection } from './components/ObjectionsSection';
import { Testimonials } from './components/Testimonials';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: PixelFunction;
    _fbq?: PixelFunction;
  }
}
const PIXEL_ID = '1762229044814828';
export function App() {
  useEffect(() => {
    try {
      if (window.fbq) return;
      const pixel = ((...args: unknown[]) => {
        if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue.push(args);
      }) as PixelFunction;
      pixel.queue = [];
      pixel.push = pixel;
      pixel.loaded = true;
      pixel.version = '2.0';
      window.fbq = pixel;
      window._fbq = pixel;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript?.parentNode) firstScript.parentNode.insertBefore(script, firstScript);else document.head.appendChild(script);
      pixel('init', PIXEL_ID);
      pixel('track', 'PageView');
    } catch {
      /* Pixel loading must never interrupt the page render. */
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="36hzxgtw5a5z">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-1" data-mp="35yngfn0fdzc" />
      </noscript>
      <div className="min-h-screen w-full overflow-x-hidden bg-cream" data-id="element-2" data-mp="d3mm3gnql5ms">
        <main data-id="element-3" data-mp="851kbcsu6dw8">
          <Hero data-id="element-4" data-mp="85bc95xfyv4k" />
          <ProblemSections data-id="element-5" data-mp="86w60tbxma1d" />
          <ModulesSection data-id="element-6" data-mp="83i0xdbvvmq8" />
          <BonusesSection data-id="element-7" data-mp="3gl4rlhg1e0k1" />
          <SystemSection data-id="element-8" data-mp="3gmfulf1nr4a3" />
          <OutcomesSection data-id="element-9" data-mp="3glo067jsrcle" />
          <ObjectionsSection data-id="element-10" data-mp="3bmbehq4nwbke" />
          <Offer data-id="element-11" data-mp="3bn2zk70muqwf" />
          <Guarantee data-id="element-12" data-mp="3bnmfji6q357t" />
          <Testimonials data-id="element-13" data-mp="3bo4j6zvpslpr" />
          <FAQ data-id="element-14" data-mp="3qb7k7gj8xchu" />
          <FinalCTA data-id="element-15" data-mp="3qbpon0g2ax0u" />
        </main>
        <Footer data-id="element-16" data-mp="3qcr0360zplj3" />
        <PurchaseToast data-id="element-17" data-mp="3qcipxlw94ubl" />
      </div>
    </>;
}